import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import InputText from "../components/Form/InputText";
import { VALUE_CODE } from "./RefundPreference";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function RefundValueCode() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    useEffect(() => {
        if (formData.refundpreference === VALUE_CODE) {
            setFormData((prev) => ({
                ...prev,
                clearingnumber: "",
                accountnumber: "",
            }));
        }
    }, [formData.compensation, setFormData]);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/personuppgifter");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}

                validationSchema={Yup.object().shape({
                    valuecodeemail: Yup.string()
                        .required("Vänligen fyll i din mejladress")
                        .email("Vänligen ange en korrekt mejladress")
                })}

            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"80"} />
                            </div>
                        </div>
                        <Form noValidate>

                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="">
                                    Värdekod
                                </h2>

                                <p>
                                    Du får värdekoden till din mejl. Värdekoden kan du sedan använda för att köpa en ny biljett.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="valuecodeemail"
                                    label={
                                        <>
                                            Mejladress för värdekod <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    autocomplete={"email"}
                                    type="text"
                                />

                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
